/*
 * Retorna uma cor em RGBA randômica
 */
export function fn_getRandomColorRgba() {
  return `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${
    Math.random() * 255
  }, 0.5)`;
}

/*
 * Retorna uma cor em hexadecimal randômica
 */
export function fn_getRandomColorHexa() {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

/*
 * Converte uma cor hexadecimal para HSLA
 */
export function fn_hexToHsla(hex, opacity) {
  if (hex && hex.length == 7) {
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;

    //Calcula os valores HSL
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h,
      s,
      l = (max + min) / 2;

    if (max === min) {
      h = s = 0; // A matiz e a saturação são 0 para cinza
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    return `hsla(${Math.round(h * 360)}, ${Math.round(s * 100)}%, ${Math.round(
      l * 100
    )}%, ${opacity})`;
  }
}

/*
 * Converte uma cor hexadecimal sem transparência (6 caracteres) em RGB
 * ou uma cor hexadecimal com transparência (8 caracteres) em RGBA
 */
export function fn_hexToRGB(hex) {
  //Remove o '#' caso esteja presente
  const cleanedHex = hex.replace("#", "");

  //Verifica se o formato é válido: 6 ou 8 caracteres
  if (!/^([0-9A-F]{6}|[0-9A-F]{8})$/i.test(cleanedHex)) {
    throw new Error("Formato de cor hexadecimal inválido");
  }

  //Extrai valores RGB
  const r = parseInt(cleanedHex.substring(0, 2), 16);
  const g = parseInt(cleanedHex.substring(2, 4), 16);
  const b = parseInt(cleanedHex.substring(4, 6), 16);

  let rgb = `rgb(${r}, ${g}, ${b})`;

  //Verifica se há componente alpha (transparência)
  if (cleanedHex.length === 8) {
    const a = parseInt(cleanedHex.substring(6, 8), 16) / 255;
    rgb = `rgba(${r}, ${g}, ${b}, ${a.toFixed(2)})`;
  }

  return rgb;
}
